import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { ProfileState } from '@/modules/profile/store/types';

const state: ProfileState = {
    info: {
        details: undefined,
        error: false,
        loading: false,
    },
    transactions: {
        list: [],
        error: false,
        loading: false,
    },
};

export const profile = {
    state,
    getters,
    mutations,
    actions,
};
